import { Component, Input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ScanStatus } from "../../../model";

@Component({
  selector: 'app-scan-status-icon',
  templateUrl: './scan-status-icon.component.html',
  styleUrls: ['./scan-status-icon.component.scss'],
  imports: [NzIconModule],
})
export class ScanStatusIconComponent {
  @Input()
  status: ScanStatus | undefined;

  @Input()
  modified: boolean = false;

  ScanStatus = ScanStatus;
}
